export default {
      id: "cov-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#cov",
      toString: function () {
        return this.url;
      }
    }